import React, { useState } from 'react';
import logo from "../../../../assets/ReEngageFollowup/img/logo.png";
import PrivacyPolicy from '../Common/PrivacyPolicy';
import TOB from "../../../../assets/pdf/re_engage_TOB.pdf";
import Complaints from '../../../../assets/pdf/re_engage_CP.pdf';

const Footer = () => {
    const [showPrivacy, setShowPrivacy] = useState(false);
    const product = localStorage.getItem("product_type");
    const modalClick = (clickValue) => {
        switch (clickValue) {
            case "showPrivacy": {
                setShowPrivacy(true);
                break;
            }
            case "exitPrivacy": {
                setShowPrivacy(false);
                break;
            }
            default: {
                break;
            }
        }
    }
    return (
        <div>
            <footer className="site-footer">
                <div className="container text-center">
                    <img src={logo} alt="tmslegal" className="footer__logo" />
                    <p className="footer__legal">
                        TMS Legal Ltd is a limited company registered in England and Wales under company no: 10315962
                        Its registered office is Arena, 9 Nimrod Way, Ferndown, BH21 7UH
                        It is authorised and regulated by the Solicitors Regulation Authority, Number: 645041
                        <br />
                        {product === "Credit Card" && <span>* credit cards average refund as of 09/10/2025</span>}
                        {product === "Hire Purchase" && <span>*Car finance average refund as of 15.10.2025</span>}

                    </p>
                    <PrivacyPolicy showPrivacy={showPrivacy} modalClick={modalClick} />

                    <nav className="footer__links">
                        <a onClick={() => modalClick("showPrivacy")}>
                            Privacy and Cookie Policy
                        </a>
                        <a href={`${TOB}`} target="_blank" style={{ color: 'white', textDecoration: 'none' }}>
                            TMS Legal Terms and Conditions
                        </a>
                        <a href={`${Complaints}`} target="_blank" style={{ color: 'white', textDecoration: 'none' }}>
                            Complaints Procedure
                        </a>

                    </nav>
                </div>

            </footer>

        </div>
    )
}

export default Footer